import usePageTitle from "@ch/helpers/hooks/usePageTitle";
import type { FC } from "react";

const NotFoundPage: FC = () => {
  usePageTitle("Page not found");

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="text-center">
        <h1>Oops!</h1>
        <div>
          <p>Sorry, the page you are looking for does not exist.</p>
          <p>
            <i>Not found</i>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
